import { rankingItems } from '@/mocks/cinema';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line',
  stable: 'ri-subtract-line',
  new: 'ri-sparkling-line',
};

const trendColor: Record<string, string> = {
  up: 'text-accent-400',
  stable: 'text-foreground-500',
  new: 'text-primary-400',
};

const rankColors = [
  'text-accent-400',
  'text-primary-400',
  'text-secondary-400',
  'text-foreground-400',
  'text-foreground-400',
  'text-foreground-500',
  'text-foreground-500',
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="section-container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-3">
            热播榜单
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            实时热度排行榜，看看大家都在追什么
          </p>
        </div>
        <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl border border-background-200/30 overflow-hidden">
          {rankingItems.map((item, i) => (
            <a
              key={item.title}
              href="#cards"
              className={`flex items-center gap-4 px-5 py-4 transition-colors duration-150 cursor-pointer hover:bg-background-100 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/20' : ''
              }`}
            >
              <span
                className={`w-8 text-center font-heading text-lg flex-shrink-0 ${rankColors[i]}`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="text-sm font-medium text-foreground-200 truncate">
                    {item.title}
                  </span>
                  <span className="text-xs text-foreground-600 whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <span className="text-xs text-foreground-600">{item.episodes}</span>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="flex items-center gap-1">
                  <span className="text-sm font-heading text-primary-400">{item.heat}</span>
                </div>
                <span className={`text-xs flex items-center gap-0.5 ${trendColor[item.trend]}`}>
                  <i className={trendIcon[item.trend]} />
                  {item.trend === 'up' ? '上升' : item.trend === 'new' ? '新上榜' : '稳定'}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}